// Страница запроса сброса пароля: пользователь вводит email,
// backend отправляет письмо с кодом.

import { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../../api/authApi';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch {
      setError('Не удалось отправить запрос. Попробуйте позже.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ewl-auth-page">
      <Container>
        <div className="ewl-auth-card">
          {/* Логотип */}
          <div className="text-center mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{
                width: '3.5rem',
                height: '3.5rem',
                borderRadius: '1rem',
                background: 'linear-gradient(135deg, #4f6ef7 0%, #7c3aed 100%)',
                fontSize: '1.5rem',
                boxShadow: '0 4px 16px rgba(79,110,247,0.35)',
              }}
            >
              📖
            </div>
            <h4 className="fw-bold mb-1" style={{ letterSpacing: '-0.01em' }}>
              English We Love
            </h4>
            <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>
              Восстановление пароля
            </p>
          </div>

          <Card
            className="border-0"
            style={{ borderRadius: '1rem', boxShadow: '0 4px 24px rgba(0,0,0,0.09)' }}
          >
            <Card.Body className="p-4">
              {error && (
                <Alert
                  variant="danger"
                  className="py-2 px-3 mb-3"
                  style={{ fontSize: '0.875rem', borderRadius: '0.5rem' }}
                >
                  {error}
                </Alert>
              )}

              {sent ? (
                <Alert
                  variant="success"
                  className="py-3 px-3 mb-0"
                  style={{ fontSize: '0.875rem', borderRadius: '0.5rem' }}
                >
                  Если этот email зарегистрирован, вы получите письмо со ссылкой для сброса пароля.
                  Проверьте почту и перейдите по ссылке из письма.
                </Alert>
              ) : (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Label className="fw-medium" style={{ fontSize: '0.875rem' }}>
                      Email
                    </Form.Label>
                    <Form.Control
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="you@example.com"
                      size="lg"
                      required
                      style={{ borderRadius: '0.5rem' }}
                    />
                  </Form.Group>

                  <Button
                    type="submit"
                    size="lg"
                    className="w-100"
                    disabled={loading}
                    style={{
                      background: 'linear-gradient(135deg, #4f6ef7 0%, #7c3aed 100%)',
                      border: 'none',
                      borderRadius: '0.6rem',
                      fontWeight: 600,
                      letterSpacing: '0.01em',
                    }}
                  >
                    {loading ? 'Отправляем...' : 'Отправить инструкции'}
                  </Button>
                </Form>
              )}
            </Card.Body>
          </Card>

          <p className="text-center mt-3 text-muted" style={{ fontSize: '0.875rem' }}>
            Вспомнили пароль?{' '}
            <Link
              to="/login"
              style={{ color: 'var(--bs-primary)', fontWeight: 500, textDecoration: 'none' }}
            >
              Войти
            </Link>
          </p>
        </div>
      </Container>
    </div>
  );
}
